"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;
exports["default"] = void 0;
var _debounce = _interopRequireDefault(require("@sd-utility/debounce"));
var _Check = _interopRequireDefault(require("@tvg/fuse-icons/lib/Check"));
var _Close = _interopRequireDefault(require("@tvg/fuse-icons/lib/Close"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _iconElement = _interopRequireDefault(require("../../fuse-icon-element/src/icon-element"));
var _styledTable = require("./styled-table");
var _excluded = ["alignment", "border", "caption", "className", "columnHeaders", "dataTestId", "layout", "rowHeaders", "rows", "title", "titleTag"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var displayName = 'Table';
var defaultProps = {
  alignment: 'centre',
  border: true,
  className: 'fuse-table',
  columnHeaders: undefined,
  dataTestId: 'fuse-table-test-id',
  layout: 'fixed',
  rowHeaders: {
    enabled: false,
    leftAlign: false
  },
  title: undefined,
  titleTag: 'h2'
};
var propTypes = {
  alignment: _propTypes["default"].oneOf(['centre', 'left']),
  border: _propTypes["default"].bool,
  caption: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  columnHeaders: _propTypes["default"].arrayOf(_propTypes["default"].string),
  dataTestId: _propTypes["default"].string,
  layout: _propTypes["default"].oneOf(['fixed', 'auto', 'expandColumnHeaders']),
  rowHeaders: _propTypes["default"].shape({
    enabled: _propTypes["default"].bool,
    leftAlign: _propTypes["default"].bool
  }),
  rows: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]))).isRequired,
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string
};
function Table(_ref) {
  var alignment = _ref.alignment,
    border = _ref.border,
    caption = _ref.caption,
    className = _ref.className,
    columnHeaders = _ref.columnHeaders,
    dataTestId = _ref.dataTestId,
    layout = _ref.layout,
    rowHeaders = _ref.rowHeaders,
    rows = _ref.rows,
    title = _ref.title,
    titleTag = _ref.titleTag,
    props = _objectWithoutProperties(_ref, _excluded);
  var tableRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflow = _useState2[0],
    setIsOverflow = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLeftFadeOverlay = _useState4[0],
    setShowLeftFadeOverlay = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showRightFadeOverlay = _useState6[0],
    setShowRightFadeOverlay = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    fadeOverlayHeights = _useState8[0],
    setFadeOverlayHeights = _useState8[1];
  var scrollHandler = function scrollHandler() {
    var element = tableRef.current;
    var scrollTotal = element.scrollWidth - element.offsetWidth;
    var scrollLeftPosition = Math.ceil(element.scrollLeft);
    if (scrollTotal === scrollLeftPosition) {
      setShowLeftFadeOverlay(true);
      setShowRightFadeOverlay(false);
    }
    if (scrollLeftPosition === 0) {
      setShowLeftFadeOverlay(false);
      setShowRightFadeOverlay(true);
    }
  };
  (0, _react.useEffect)(function () {
    var element = tableRef.current;
    setIsOverflow(element.scrollWidth > element.clientWidth);
    setShowRightFadeOverlay(element.scrollWidth > element.clientWidth);
    setFadeOverlayHeights(element.clientHeight);
    var handleResize = (0, _debounce["default"])(function () {
      setIsOverflow(element.scrollWidth > element.clientWidth);
      setShowRightFadeOverlay(element.scrollWidth > element.clientWidth);
      setFadeOverlayHeights(element.clientHeight);
    }, 200);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var hasColumnHeaders = columnHeaders && columnHeaders.some(function (el) {
    return el;
  });
  var rowContainsIcon = function rowContainsIcon(row) {
    return row.includes(true) || row.includes(false);
  };
  var cellDataText = function cellDataText(content, header) {
    return /*#__PURE__*/_react["default"].createElement(_styledTable.StyledCellText, {
      size: {
        xxs: 'm2',
        m: 'm1'
      },
      tag: "p",
      type: header ? 'heading' : 'paragraph'
    }, content);
  };
  var cellDataIconTick = /*#__PURE__*/_react["default"].createElement(_iconElement["default"], {
    className: "fuse-table__table-cell-icon--tick",
    icon: /*#__PURE__*/_react["default"].createElement(_Check["default"], null),
    color: "var(--color-functional-successMid)",
    responsiveSize: "small",
    srLabel: "Tick Icon"
  });
  var cellDataIconCross = /*#__PURE__*/_react["default"].createElement(_iconElement["default"], {
    className: "fuse-table__table-cell-icon--cross",
    icon: /*#__PURE__*/_react["default"].createElement(_Close["default"], null),
    color: "var(--color-functional-errorMid)",
    responsiveSize: "small",
    srLabel: "Cross Icon"
  });
  var dataCellKey = function dataCellKey(row, cell) {
    return "row".concat(row, " - cell").concat(cell);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTableWrapper, _extends({
    className: className,
    "data-testid": dataTestId
  }, props), title && /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTitle, {
    size: {
      xxs: '3',
      m: '5'
    },
    tag: titleTag,
    type: "heading"
  }, title), /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTableScrollWrapper, {
    ref: tableRef,
    onScroll: scrollHandler,
    tabindex: "0"
  }, isOverflow && /*#__PURE__*/_react["default"].createElement(_styledTable.StyledFadeOverlayWrapper, null, /*#__PURE__*/_react["default"].createElement(_styledTable.StyledLeftFadeOverlay, {
    className: !showLeftFadeOverlay && 'hidden',
    style: {
      height: "".concat(fadeOverlayHeights, "px")
    }
  }), /*#__PURE__*/_react["default"].createElement(_styledTable.StyledRightFadeOverlay, {
    className: !showRightFadeOverlay && 'hidden',
    style: {
      height: "".concat(fadeOverlayHeights, "px")
    }
  })), /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTable, {
    alignment: alignment,
    border: border,
    hasColumnHeaders: hasColumnHeaders,
    layout: layout
  }, /*#__PURE__*/_react["default"].createElement(_styledTable.StyledCaption, null, /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, null, caption)), hasColumnHeaders && /*#__PURE__*/_react["default"].createElement("thead", {
    className: "fuse-table__table-thead"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "fuse-table-table-row"
  }, columnHeaders.map(function (content, columnIndex) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      // eslint-disable-next-line react/no-array-index-key
      key: "columnHeader - ".concat(columnIndex),
      className: "fuse-table__table-column-header"
    }, cellDataText(content, true));
  }))), /*#__PURE__*/_react["default"].createElement("tbody", {
    className: "fuse-table__table-tbody"
  }, rows.map(function (row, rowIndex) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      // eslint-disable-next-line react/no-array-index-key
      key: rowIndex,
      className: "fuse-table-table-row"
    }, row.map(function (content, cellIndex) {
      if (typeof content === 'string') {
        if (rowHeaders.enabled && cellIndex === 0) {
          return /*#__PURE__*/_react["default"].createElement(_styledTable.StyledRowHeader, {
            key: dataCellKey(rowIndex, cellIndex),
            scope: "row",
            leftAlign: rowHeaders.leftAlign
          }, cellDataText(content, true));
        }
        return /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTableData, {
          key: dataCellKey(rowIndex, cellIndex),
          vAlignMiddle: rowContainsIcon(row)
        }, cellDataText(content));
      }
      return /*#__PURE__*/_react["default"].createElement(_styledTable.StyledTableData, {
        key: dataCellKey(rowIndex, cellIndex),
        hasCellIcon: true
      }, /*#__PURE__*/_react["default"].createElement(_styledTable.StyledCellIconWrapper, {
        alignment: alignment
      }, content ? cellDataIconTick : cellDataIconCross));
    }));
  })))));
}
Table.displayName = displayName;
Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
var _default = exports["default"] = Table;